import React from 'react';

import { formatMoney } from '@betterment/core';
import { Box, Text } from '@betterment/samba-react';
import { numberRoundDownWithDecimals } from '@betterment/shared-components';

import { HighlightRow, Purpose } from './HighlightRow';

import { ProjectedBalanceTooltip } from '../ProjectedBalanceTooltip';

export const EmergencyFundHighlights: React.FC<{ purpose: Purpose<'PurposeEmergencyFund'> }> = ({ purpose }) => {
  const projection = purpose.emergencyFundProjection;
  const timeSeries = projection.balanceTimeSeries;
  if (!timeSeries) return null;

  const target = purpose.emergencyFundTarget;
  const firstPoint = timeSeries[0];
  const finalPoint = timeSeries[timeSeries.length - 1];

  const years = finalPoint.date.getFullYear() - firstPoint.date.getFullYear();
  const projectedBalanceTitle = `Projected in ${years} year${years === 1 ? '' : 's'}`;

  return (
    <>
      <HighlightRow>
        <HighlightRow.Leading>
          <Box css={{ display: 'flex', gap: 'space.50' }}>
            <Text variant="text100">{projectedBalanceTitle}</Text>
            <ProjectedBalanceTooltip />
          </Box>
          <Text variant="text50" color="text.weak">
            {numberRoundDownWithDecimals(projection.monthsExpensesCovered, 1)} months expenses
          </Text>
        </HighlightRow.Leading>
        <HighlightRow.Trailing>
          <Text variant="text100">{formatMoney(finalPoint.expected)}</Text>
        </HighlightRow.Trailing>
      </HighlightRow>
      {target && (
        <HighlightRow>
          <HighlightRow.Leading>
            <Text variant="text100">Savings target</Text>
            <Text variant="text50" color="text.weak">
              {numberRoundDownWithDecimals(target.monthsExpensesCovered, 1)} months expenses
            </Text>
          </HighlightRow.Leading>
          <HighlightRow.Trailing>
            <Text variant="text100">{formatMoney(target.amount)}</Text>
          </HighlightRow.Trailing>
        </HighlightRow>
      )}
    </>
  );
};
